<template>
  <question-base-wrapper v-bind="baseWrapperProps">
    <validation-provider
      v-slot="{ failed }"
      :vid="`${stepId}_${questionId}`"
      :name="questionId"
    >
      <checkbox-button
        v-for="(option, optionKey) in optionsList"
        :key="optionKey"
        v-model="questionData[optionKey]"
        :error="failed"
        class="mb-4"
        :data-test="snakeCase(optionKey)"
        @click.native="updateLocalStorage"
      >
        {{ getOptionText(option) }}
      </checkbox-button>
    </validation-provider>
  </question-base-wrapper>
</template>

<script>
import QuestionBase from './Base';
import QuestionBaseWrapper from './BaseWrapper';

export default {
  name: 'cover-type-travel',
  extends: QuestionBase,
  inject: ['productName'],
  components: { QuestionBaseWrapper },
  data () {
    return {
      fields: this.customFields,
    };
  },
  computed: {
    optionsList () {
      return this.optionsConfig.options;
    },
  },
  created () {
    this.updateLocalStorage();
  },
  methods: {
    updateLocalStorage () {
      const selectedOptions = this.$ls.get(this.productName + '__selected-options') || this.$ls.get('selected-options');

      if (!selectedOptions?.optionalExtras) return;
      delete selectedOptions.optionalExtras;

      this.$ls.set(this.productName + '__selected-options', selectedOptions);
    },
    getOptionText (option) {
      return option?.title || option;
    },
  },
};
</script>
